
import { FSXABaseRichTextElement } from 'fsxa-pattern-library'
import { Component } from 'nuxt-property-decorator'

@Component({ name: 'Listitem' })
export default class Listitem extends FSXABaseRichTextElement {}
